import { render, staticRenderFns } from "./CorporateEdit.vue?vue&type=template&id=060cc958&scoped=true&"
import script from "./CorporateEdit.vue?vue&type=script&lang=js&"
export * from "./CorporateEdit.vue?vue&type=script&lang=js&"
import style0 from "./CorporateEdit.vue?vue&type=style&index=0&id=060cc958&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060cc958",
  null
  
)

export default component.exports